export default "__VITE_PUBLIC_ASSET__03d276a7__"